import { useAtom } from "jotai";
import { Moon, Sun } from "lucide-react";
import { useEffect } from "react";

import { themeAtom } from "@lib/state.ts";

export function ThemeToggle() {
  const [theme, setTheme] = useAtom(themeAtom);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      className="rounded-sm2 p-1.5 text-muted transition hover:bg-surface-2 hover:text-ink"
    >
      {theme === "dark" ? (
        <Sun className="size-4" aria-hidden />
      ) : (
        <Moon className="size-4" aria-hidden />
      )}
    </button>
  );
}
